export default {
  fa: {
    doctorId: 'شناسه پزشک',
    clinicId: 'شناسه مرکز',
    title: 'پیگیری درخواست‌های نوبت',
    hint: 'درخواست‌های دارای شماره تأییدشده تا ۹۰ روز نمایش داده می‌شوند. وضعیت پیگیری، نتیجه رزرو را تغییر نمی‌دهد.',
    booking: 'وضعیت رزرو',
    care: 'وضعیت پیگیری',
    all: 'همه',
    filter: 'نمایش درخواست‌ها',
    refresh: 'تازه‌سازی',
    loading: 'در حال دریافت درخواست‌ها…',
    empty: 'درخواستی با این شرایط پیدا نشد.',
    failed: 'دریافت درخواست‌ها انجام نشد. دوباره تلاش کنید.',
    session: 'نشست شما تمام شده؛ دوباره وارد شوید.',
    forbidden: 'اجازه دسترسی به این بخش را ندارید.',
    unavailable: 'در حال حاضر دریافت فهرست ممکن نیست. کمی بعد دوباره تلاش کنید.',
    name: 'نام',
    phone: 'شماره تماس',
    doctor: 'پزشک',
    clinic: 'مرکز',
    verified: 'زمان تأیید شماره',
    confirmed: 'رزرو تأیید شده',
    rejected: 'رزرو انجام نشد',
    unknown: 'نتیجه رزرو مشخص نیست',
    submitting: 'در حال ارسال رزرو',
    pending: 'نیاز به پیگیری',
    contacted: 'تماس گرفته شد',
    closed: 'پیگیری تمام شد',
    save: 'ذخیره پیگیری',
    saving: 'در حال ذخیره…',
    saved: 'وضعیت پیگیری ذخیره شد.',
    updateFailed: 'ذخیره تأیید نشد. فهرست را تازه کنید و وضعیت را بررسی کنید.',
    conflict: 'این درخواست تغییر کرده است. فهرست را تازه کنید و دوباره بررسی کنید.',
    previous: 'صفحه قبل',
    next: 'صفحه بعد',
    page: 'صفحه',
    total: 'تعداد درخواست‌ها',
    missing: 'ثبت نشده',
    unknownHint: 'نتیجه نامشخص به معنی رزرو قطعی نیست. پیش از اقدام دوباره، وضعیت را با مرکز بررسی کنید.',
    readOnly: 'دسترسی شما فقط برای مشاهده است.',
  },
  en: {
    doctorId: 'Doctor ID',
    clinicId: 'Clinic ID',
    title: 'Booking follow-up',
    hint: 'Requests with an SMS-verified phone are available for 90 days. Follow-up progress does not change the booking outcome.',
    booking: 'Booking status',
    care: 'Follow-up status',
    all: 'All',
    filter: 'Show requests',
    refresh: 'Refresh',
    loading: 'Loading requests…',
    empty: 'No requests match these filters.',
    failed: 'Requests could not be loaded. Please try again.',
    session: 'Your session has expired. Sign in again.',
    forbidden: 'You do not have access to this page.',
    unavailable: 'The request list is currently unavailable. Please try again shortly.',
    name: 'Name',
    phone: 'Phone',
    doctor: 'Doctor',
    clinic: 'Clinic',
    verified: 'Phone verified at',
    confirmed: 'Booking confirmed',
    rejected: 'Booking unsuccessful',
    unknown: 'Booking outcome unknown',
    submitting: 'Submitting booking',
    pending: 'Needs follow-up',
    contacted: 'Contacted',
    closed: 'Follow-up complete',
    save: 'Save follow-up',
    saving: 'Saving…',
    saved: 'Follow-up status saved.',
    updateFailed: 'Saving could not be confirmed. Refresh the list and check the status.',
    conflict: 'This request has changed. Refresh the list and check again.',
    previous: 'Previous page',
    next: 'Next page',
    page: 'Page',
    total: 'Total requests',
    missing: 'Not recorded',
    unknownHint: 'An unknown outcome is not a confirmed booking. Check with the clinic before trying again.',
    readOnly: 'You have view-only access.',
  },
  ar: {
    doctorId: 'معرّف الطبيب',
    clinicId: 'معرّف المركز',
    title: 'متابعة طلبات المواعيد',
    hint: 'تظهر الطلبات ذات الأرقام المؤكدة برسالة نصية لمدة ٩٠ يومًا. حالة المتابعة لا تغيّر نتيجة الحجز.',
    booking: 'حالة الحجز',
    care: 'حالة المتابعة',
    all: 'الكل',
    filter: 'عرض الطلبات',
    refresh: 'تحديث',
    loading: 'جارٍ تحميل الطلبات…',
    empty: 'لا توجد طلبات تطابق هذه الخيارات.',
    failed: 'تعذّر تحميل الطلبات. حاول مرة أخرى.',
    session: 'انتهت جلستك. سجّل الدخول مجددًا.',
    forbidden: 'ليس لديك صلاحية الوصول إلى هذه الصفحة.',
    unavailable: 'لا يمكن تحميل قائمة الطلبات حاليًا. حاول مرة أخرى بعد قليل.',
    name: 'الاسم',
    phone: 'رقم الهاتف',
    doctor: 'الطبيب',
    clinic: 'المركز',
    verified: 'وقت تأكيد الرقم',
    confirmed: 'تم تأكيد الحجز',
    rejected: 'لم يتم الحجز',
    unknown: 'نتيجة الحجز غير معروفة',
    submitting: 'جارٍ إرسال الحجز',
    pending: 'بحاجة إلى متابعة',
    contacted: 'تم التواصل',
    closed: 'اكتملت المتابعة',
    save: 'حفظ المتابعة',
    saving: 'جارٍ الحفظ…',
    saved: 'تم حفظ حالة المتابعة.',
    updateFailed: 'تعذّر تأكيد الحفظ. حدّث القائمة وتحقق من الحالة.',
    conflict: 'تم تغيير هذا الطلب. حدّث القائمة وتحقق مجددًا.',
    previous: 'الصفحة السابقة',
    next: 'الصفحة التالية',
    page: 'الصفحة',
    total: 'عدد الطلبات',
    missing: 'غير مسجّل',
    unknownHint: 'النتيجة غير المعروفة لا تعني تأكيد الحجز. تحقق من المركز قبل المحاولة مجددًا.',
    readOnly: 'صلاحيتك تتيح العرض فقط.',
  },
}
